import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import deepmerge from 'deepmerge';

var canUseSymbol = typeof Symbol === 'function' && Symbol["for"];
var REACT_ELEMENT = canUseSymbol ? Symbol["for"]('react.element') : 0xeac7;
var FORWARD_REF = canUseSymbol ? Symbol["for"]('react.forward_ref') : 0xeac7;
var deepmergeOptions = {
  isMergeableObject: function isMergeableObject(n) {
    return !!n && _typeof(n) === 'object' && n.$$typeof !== REACT_ELEMENT && n.$$typeof !== FORWARD_REF;
  },
  arrayMerge: function arrayMerge(_leftArray, rightArray) {
    return rightArray;
  }
};

/**
 * Deeply merge themes
 */
var merge = function merge(a, b) {
  return deepmerge(a, b, deepmergeOptions);
};
function mergeAll() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return deepmerge.all(args, deepmergeOptions);
}
merge.all = mergeAll;

export { merge };
//# sourceMappingURL=merge-theme.esm.js.map
